export default __webpack_public_path__ + "static/media/description_icon.d40334d9.png";